import { cn } from "@/lib/cn";
import { formatPoints, type PointsUnit } from "@/lib/format-points";
import { forwardRef, type HTMLAttributes } from "react";
import { TEXT_SIZES, TEXT_WEIGHTS, useTextToneClass, type TextTone } from "./Typography";

/** Props of `Points`; without `unit` it renders the bare number. */
export type PointsProps = Omit<HTMLAttributes<HTMLSpanElement>, "children" | "color"> & {
  value: number;
  unit?: PointsUnit;
  size?: keyof typeof TEXT_SIZES;
  weight?: keyof typeof TEXT_WEIGHTS;
  tone?: TextTone;
};

/** Loyalty points through `formatPoints`, tabular so counters do not jitter. */
export const Points = forwardRef<HTMLSpanElement, PointsProps>(function Points(
  { value, unit, size, weight, tone, className, ...rest },
  ref,
) {
  const toneClass = useTextToneClass(tone);
  return (
    <span
      {...rest}
      ref={ref}
      className={cn("whitespace-nowrap tabular-nums", size && TEXT_SIZES[size], weight && TEXT_WEIGHTS[weight], toneClass, className)}
    >
      {formatPoints(value, unit)}
    </span>
  );
});
